import "./App.css";
import styles from "./App.module.css";
import React, { useEffect, useState } from "react";
import { Route, Routes, Outlet, Router, Navigate } from "react-router-dom";
import LoginForm from "./components/login/loginForm";
import ProjectScreen from "./components/Admin/projectScreen/projectScreen";
import AddProject from "./components/Admin/addProject/addProject";
import ErrorPage from "./components/errorPage";
import AddParticipants from "./components/Admin/addParticipants/addParticipants";
import AddSuperAdmin from "./components/Admin/addSuperAdmin/addSuperAdmin";
import Projects from "./components/Admin/projects/projects";
import AddAssets from "./components/Admin/addAssets/addAssets";
import BreakRoom from "./components/CommonModules/beakRoomListing/breakRoom";
import { Game } from "./components/CommonModules/Games/sodukuGame/Game";
import { SudokuProvider } from "./components/CommonModules/Games/sodukuGame/context/SudokuContext";
import RememberCards from "./components/CommonModules/Games/rememberCardsGame/Game";
import PhotoBooth from "./components/CommonModules/photobooth/photoBooth";
import MosaicWall from "./components/CommonModules/mosaicWall/mosaicWall";
import ChatLogin from "./components/CommonModules/chatModule/chatLogin/chatLogin";

import ProtectedRoute from "./components/common/protectedRoute";

import LoginFormNonVodafone from "./components/login/loginFormNonVodafone";
import ResetPassword from "./components/reset/resetPassword";
import Addparts from "./components/Admin/addAdmins/addparts";
import UserManagementProfiles from "./components/Admin/userManagementProfiles/userManagementProfiles";
import AboutMainScreen from "./components/Admin/addAboutProject/aboutMainScreen";
import AboutProject from "./components/Admin/aboutProject/aboutProject";
import StatsCriteria from "./components/Admin/statsCriteria/statsCriteria";

// import AscentionDemoRoomsManagement from "./components/Admin/manageAscentionDemoRooms/ascentionDemoRoomsManagement";

import ThirdAscensionEntranceVideo from "./3rdAscensionDay/EntranceVideo/EntranceVideo";
import ThirdAscensionHall from "./3rdAscensionDay/hall1/ThirdAscensionHall";
import ThirdAscensionPhotoBoothEntrance from "./3rdAscensionDay/photoboothEntrance/ThirdAscensionPhotoBoothEntrance";
import ThirdAscensionPhotoBoothEntrance2 from "./3rdAscensionDay/photoboothEntrance2/ThirdAscensionPhotoBoothEntrance2";
import ThirdAscensionTakePhoto from "./3rdAscensionDay/TakePhoto/ThirdAscensionTakePhoto";
import ThirdAscensionGallerywall from "./3rdAscensionDay/galleryWall/ThirdAscensionGallerywall";
import ThirdAscensionKeyNotes from "./3rdAscensionDay/KeyNotes/ThirdAscensionKeyNotes";
import { getCurrentUser, getJwt } from "./services/authService";
import ShowRoomMainHall from "./ShowRoom/ShowRoomMainHall";
import ShowRoomOPCHall from "./ShowRoom/OPC/ShowRoomOPCHall";
import ShowRoomTesHall from "./ShowRoom/TES/ShowRoomTesHall";
import ShowRoomBQAHall from "./ShowRoom/BQA/ShowRoomBQAHall";
import HRComingSoon from "./ShowRoom/HR/HRComingSoon";
import SEAHall from "./ShowRoom/SEA/SEAHall";
import TestingHall from "./ShowRoom/SEA/testing/TestingHall";
import TesingAboutUs from "./ShowRoom/SEA/testing/TestingAboutUs";
import TestingContactUs from "./ShowRoom/SEA/testing/TestingContactUs";
import DSMHall from "./ShowRoom/SEA/dsm/DSMHall";
import DSMCatalgue from "./ShowRoom/SEA/dsm/DSMCatalgue";
import DSMAboutUs from "./ShowRoom/SEA/dsm/DSMAboutUs";
import DSMContactUs from "./ShowRoom/SEA/dsm/DSMContactUs";
import DevOpsHall from "./ShowRoom/SEA/devops/DevOpsHall";
import DevOpsAboutUs from "./ShowRoom/SEA/devops/DevOpsAboutUs";
import DevOpsContactUs from "./ShowRoom/SEA/devops/DevOpsContactUs";
import BPMHall from "./ShowRoom/SEA/bpm/BPMHall";
import BPMAboutUs from "./ShowRoom/SEA/bpm/BPMAboutUs";
import BPMContactUs from "./ShowRoom/SEA/bpm/BPMContactUs";
import RPAHall from "./ShowRoom/SEA/rpa/RPAHall";
import RPAAboutUs from "./ShowRoom/SEA/rpa/RPAAboutUs";
import RPAContactUs from "./ShowRoom/SEA/rpa/RPAContactUs";
import DigitalToolingHall from "./ShowRoom/SEA/digitalTooling/DigitalToolingHall";
import DigitalToolingAboutUs from "./ShowRoom/SEA/digitalTooling/DigitalToolingAboutUs";
import DigitalToolingContactUs from "./ShowRoom/SEA/digitalTooling/DigitalToolingContactUs";
import COEHall from "./ShowRoom/SEA/coe/COEHall";
import COEAboutUs from "./ShowRoom/SEA/coe/COEAboutUs";
import COEContactUs from "./ShowRoom/SEA/coe/COEContactUs";
import PMOHall from "./ShowRoom/SEA/pmo/PMOHall";
import PMOAboutUs from "./ShowRoom/SEA/pmo/PMOAboutUs";
import PMOContactUs from "./ShowRoom/SEA/pmo/PMOContactUs";
import ProductivityHall from "./ShowRoom/SEA/productivity/ProductivityHall";
import ProductivityAboutUs from "./ShowRoom/SEA/productivity/ProductivityAboutUs";
import ProductivityContactUs from "./ShowRoom/SEA/productivity/ProductivityContactUs";
import SEHall from "./ShowRoom/SE/SEHall";
import ProjectsHall from "./ShowRoom/SE/Projects/ProjectsHall";
import GuildsCatalogue from "./ShowRoom/SE/Guilds/GuildsCatalogue";
import GuildsHall from "./ShowRoom/SE/Guilds/GuildsHall";
import ShowRoomAOHall from "./ShowRoom/AO/ShowRoomAOHall";
import OITHall from "./ShowRoom/OIT/OITHall";
import VCIHall from "./ShowRoom/OIT/VCI/VCIHall";
import RTCHall from "./ShowRoom/OIT/RTC/RTCHall";
import SDHall from "./ShowRoom/OIT/SD/SDHall";
import ITTSHall from "./ShowRoom/OIT/IT-TS/IT-TSHall";
import InfrastructureHall from "./ShowRoom/OIT/Infrastructure/InfrastructureHall";
import OSHall from "./ShowRoom/OIT/OS/OSHall";
import CollaborationsHall from "./ShowRoom/OIT/Collaborations/CollaborationsHall";
import ITSHall from "./ShowRoom/OIT/ITS/ITSHall";
import HWHall from "./ShowRoom/OIT/HW/HWHall";
import ThirdAscensionBreakAreaEntrance from "./3rdAscensionDay/BreakAreaEntrance/ThirdAscensionBreakAreaEntrance";
import ThirdAscensionChatEntrance from "./3rdAscensionDay/ChatEntrance1/ThirdAscensionChatEntrance";
import ThirdAscensionChatRooms from "./3rdAscensionDay/ChatEntrance2/ThirdAscensionChatRooms";
import { setJwt } from "./services/httpService";
import AscensionHome from "./3rdAscensionDay/AscensionHome/AscensionHome";
import AscensionGameEntrance from "./3rdAscensionDay/AscensionGameEntrance/AscensionGameEntrance";
import AscensionDayGame from "./3rdAscensionDay/AscensionGameEntrance/AscensionDayGame/AscensionDayGame";
import Entrance from "./components/login/entrance";
import axios from "axios";
import { useIdleTimer } from "react-idle-timer";

import Main from "./components/WebAR/Main/Main";
import AdminDashBoard from "./components/WebAR/Survey/AdminDashBoard";
import EarthAr from "./earthAr/EarthAr";
import EarthSplashScreen from "./earthAr/landing/EarthSplashScreen";
import Onboarding from "./components/onboarding/Onboarding";
import Hall from "./hackathon/Hall";
import WIVAChatEnryPage from "./WIVA/WIVAChatEnryPage/WIVAChatEnryPage";
import WIVAChatCreateRoom from "./WIVA/WIVAChatEnryPage/WIVAChatCreateRoom";
import WIVALiveChat from "./WIVA/WIVALiveChat/WIVALiveChat";
import WIVAMainStage from "./WIVA/WIVAMainStage/WIVAMainStage";
import WIVANewsLetter from "./WIVA/WIVANewsLetter/WIVANewsLetter";
import WIVAConfigPage from "./WIVA/WIVAConfigPage/WIVAConfigPage";
import WIVAHome from "./WIVA/Home/WIVAHome";
import WIVAPhotoBoothEntrance from "./WIVA/WIVAPhotoBoothEntrance/WIVAPhotoBoothEntrance";
import WIVAVideos from "./WIVA/WIVAVideos/WIVAVideos";
import WivaVistorPass from "./WIVA/WIVAVisitorPass/WivaVistorPass";
import WIVAPhotobooth from "./WIVA/WIVAPhotobooth/WIVAPhotobooth";
import WIVAMosaicWall from "./WIVA/WIVAMosaicWall/WIVAMosaicWall";
import WIVASponcers from "./WIVA/WIVASponcers/WIVASponcers";
import WIVAHome2 from "./WIVA/Home2/WIVAHome2";
import { useNavigate } from "react-router-dom";
import AddAdmins from "./components/Admin/addAdmins/addadmins";
import { isMobile } from "react-device-detect";
import WivaTemplateConfig from "./WIVA/WIVATemplateConfig/WivaTemplateConfig";
import WivaViewMailTemplate from "./WIVA/WIVATemplateConfig/WivaViewMailTemplate/WivaViewMailTemplate";
// import AgendaConfiguire from "./ThirdAscension/AgendaConfigure/AgendaConfiguire";
// import ThirdAscAgenda from "./ThirdAscension/Agenda/Agenda";
import { getIdToken } from "./components/Auth/authProvider";
import Cookies from "js-cookie";
import AdminProtectedRoute from "./components/common/AdminProtectedRoute";
// import SummitHall1 from "./Summit2022/summitHall1";
function App() {
  const q = new URLSearchParams(window.location.search) || "";

  const [current, setCurrent] = React.useState();
  const [state, setState] = useState("Active");
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  let navigate = useNavigate();
  useEffect(() => {
    if (isMobile && window.location.pathname.includes("wiv")) {
      function handleOrientationChange() {
        if (window.matchMedia("(orientation: portrait)").matches) {
          console.log("Portrait mode");
          // Custom code for portrait orientation
          document.getElementById("wivamobilebtn").click();
          if (
            document.getElementById("wivawelcome").className.includes("show")
          ) {
            document.getElementById("wivawelcomebtn").click();
          }
        } else if (window.matchMedia("(orientation: landscape)").matches) {
          console.log("Landscape mode");
          // Custom code for landscape orientation
          if (
            document.getElementById("wivamobile").className.includes("show")
          ) {
            document.getElementById("wivamobilebtn").click();
          }
          if (
            window.localStorage.getItem("firsttime") == "true" ||
            window.localStorage.getItem("firsttime") == null ||
            window.localStorage.getItem("firsttime") == undefined
          ) {
            if (
              window.location.href.endsWith("/wiv/#") ||
              window.location.href.endsWith("/wiv/") ||
              window.location.href.endsWith("/wiv") ||
              window.location.href.endsWith("/wiv#")
            ) {
              setTimeout(() => {
                document.getElementById("wivawelcomebtn").click();
                debugger;
                document.body.classList.add("modal-open");
              }, 500);
            }
          } else {
            if (document.getElementById("iframe")) {
              document.getElementById("iframe").focus();
            }
          }
        }
      }

      // Add event listener for orientation change
      window.addEventListener("resize", handleOrientationChange);

      // Initial check
      handleOrientationChange();
    }
  }, []);
  const addWivaLink = () => {
    if (window.location.pathname.includes("wiv")) {
      getCurrentUser().then((r) =>
        axios
          .post(`${process.env.REACT_APP_SERVER_URL}wivalinks/`, {
            email: r.preferred_username,
            link: window.location.pathname,
          })
          .then((res) => {})
      );
    }
  };

  const onIdle = () => {
    getCurrentUser().then((r) => {
      if (r && r.preferred_username) {
        axios
          .post(`${process.env.REACT_APP_SERVER_URL}auth/logout`, {
            email: r.preferred_username,
          })
          .then(() => {
            Cookies.remove("app_token");
            sessionStorage.removeItem("app_token");
            console.log("User session timed out - logging out silently");
            window.location.href = "/"; // Redirect to login page
          });
      }
    });
  };

  const onActive = () => {
    setState("Active");
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const handleDuplicateLogin = () => {
    // Get the current user's email
    getCurrentUser().then((r) => {
      if (r && r.preferred_username) {
        // Call logout API to expire previous tokens
        axios
          .post(`${process.env.REACT_APP_SERVER_URL}auth/logout`, {
            email: r.preferred_username,
          })
          .then(() => {
            // Store current URL parameters before refresh
            const currentUrl = window.location.href;
            const urlObj = new URL(currentUrl);
            const searchParams = urlObj.searchParams;

            // Store any important parameters in localStorage
            if (searchParams.has("name")) {
              localStorage.setItem("wivaVideoParam", searchParams.get("name"));
            }

            // Refresh the page to allow new login
            window.location.reload();
          });
      }
    });
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 7_200_000,
    throttle: 500,
  });

  useEffect(() => {
    debugger;
    getCurrentUser().then((r) => {
      setCurrent(r);
      if (
        r == null &&
        window.location.pathname != "/" &&
        window.location.pathname != "/entrance"
      ) {
        localStorage.setItem("Requested", window.location.pathname);
        localStorage.setItem("q", q);
        navigate("/home");
      }
      if (window.location.pathname == "/" && r != null) {
        navigate("/entrance");

        localStorage.removeItem("Requested");
        localStorage.removeItem("q");
      }
    });

    addWivaLink();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });
  return (
    <>
      <button
        type='button'
        class='btn btn-primary'
        data-bs-toggle='modal'
        data-bs-target='#wivamobile'
        id='wivamobilebtn'
        style={{ display: "none" }}
      >
        wivamobile
      </button>
      <div
        className='modal fade '
        id='wivamobile'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
        data-backdrop='static'
        data-keyboard='false'
      >
        <div
          className={styles["wiv-modal"] + " modal-dialog  "}
          role='document'
        >
          <div className='modal-content wiv-popup'>
            <div
              className='modal-body row'
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "5% 10%",
              }}
            >
              <div className={styles["wiv-inner-div"] + " col-md-12"}>
                <div className='row'>
                  <div className={styles["wiv-mobile-tip"] + " col-md-6"}>
                    <img src='/wiv/rotatemobile.svg' />
                    <span className={styles["wiv-tip-mobile-text-bolder"]}>
                      Unlock The Full Experience!
                    </span>
                    <span className={styles["wiv-tip-mobile-text"]}>
                      This Content Is Best Viewed In Landscape Mode.
                    </span>
                    <span className={styles["wiv-tip-mobile-text"]}>
                      Rotate Your Phone To Landscape Mode For An Awesome View.
                    </span>
                  </div>
                </div>
                {/* <span
                  className={styles["wiv-btn"]}
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={() => {
                    if (document.getElementById("iframe")) {
                      document.getElementById("iframe").focus();
                    }
                  }}
                >
                  Get Started
                </span> */}
              </div>
              {/*..<p>This User is logged in from another browser</p> */}
            </div>
          </div>
        </div>
      </div>
      <button
        type='button'
        class='btn btn-primary'
        data-bs-toggle='modal'
        data-bs-target='#wivawelcome'
        id='wivawelcomebtn'
        style={{ display: "none" }}
      >
        wivawelcome
      </button>
      <div
        className='modal fade '
        id='wivawelcome'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
        data-backdrop='static'
        data-keyboard='false'
      >
        <div
          className={styles["wiv-modal"] + " modal-dialog modal-lg "}
          role='document'
        >
          <div className='modal-content wiv-popup'>
            <div
              className='modal-body row'
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "5% 10%",
              }}
            >
              <div className={styles["wiv-inner-div"] + " col-md-12"}>
                <span className={styles["wiv-modal-header"]}>
                  Welcome,{" "}
                  {current ? current.preferred_username.split(".")[0] : ""} 🎉
                </span>
                <span className={styles["wiv-tips-to-navigate"]}>
                  Tips To Navigate Around
                </span>
                <div className='row'>
                  {isMobile ? (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <img
                        src='/wiv/InstructionNavigate.svg'
                        className={styles["img"]}
                      ></img>
                      <span className={styles["wiv-tip-text"]}>
                        Navigate around the hall by dragging{" "}
                        <span className={styles["wiv-tip-text-bolder"]}>
                          The Arrows{" "}
                        </span>
                        button all around.
                      </span>
                    </div>
                  ) : (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='113'
                        height='78'
                        viewBox='0 0 113 78'
                        fill='none'
                      >
                        <path
                          d='M30.6556 40.1777H5.2658C2.36296 40.1777 0 42.5394 0 45.4423V71.9508C0 74.8549 2.36296 77.2154 5.2658 77.2154H30.6556C33.5597 77.2154 35.9214 74.8537 35.9214 71.9508V45.4423C35.9214 42.5394 33.5597 40.1777 30.6556 40.1777ZM25.4288 42.4955C27.4665 42.4955 29.1251 44.1528 29.1251 46.1881V65.9782C29.1251 68.0159 27.4665 69.6732 25.4288 69.6732H10.1198C8.08327 69.6732 6.42593 68.0159 6.42593 65.9782V46.1881C6.42593 44.1528 8.08327 42.4955 10.1198 42.4955H25.4288ZM0.822389 45.4423C0.822389 42.9927 2.81621 41.0014 5.2658 41.0014H27.7189L25.371 41.6706H10.1198C7.63001 41.6706 5.60229 43.6958 5.60229 46.1881V65.8162L0.822389 70.9125V45.4423Z'
                          fill='#E60000'
                        />
                        <path
                          d='M69.1941 40.1777H43.8068C40.9027 40.1777 38.541 42.5394 38.541 45.4423V71.9508C38.541 74.8549 40.9027 77.2154 43.8068 77.2154H69.1941C72.0983 77.2154 74.4599 74.8537 74.4599 71.9508V45.4423C74.4612 42.5394 72.0995 40.1777 69.1941 40.1777ZM63.9685 42.4955C66.0063 42.4955 67.6636 44.1528 67.6636 46.1881V65.9782C67.6636 68.0159 66.0063 69.6732 63.9685 69.6732H48.6595C46.6218 69.6732 44.9657 68.0159 44.9657 65.9782V46.1881C44.9657 44.1528 46.6218 42.4955 48.6595 42.4955H63.9685ZM39.3634 45.4423C39.3634 42.9927 41.3572 41.0014 43.8068 41.0014H66.2587L63.912 41.6706H48.6595C46.1685 41.6706 44.1408 43.6958 44.1408 46.1881V65.8162L39.3621 70.9125V45.4423H39.3634Z'
                          fill='#E60000'
                        />
                        <path
                          d='M69.1941 0H43.8068C40.9027 0 38.541 2.3617 38.541 5.2658V31.7743C38.541 34.6772 40.9027 37.0414 43.8068 37.0414H69.1941C72.0983 37.0414 74.4599 34.6772 74.4599 31.7743V5.2658C74.4612 2.3617 72.0995 0 69.1941 0ZM63.9685 2.31776C66.0063 2.31776 67.6636 3.97509 67.6636 6.0116V25.8004C67.6636 27.8382 66.0063 29.4955 63.9685 29.4955H48.6595C46.6218 29.4955 44.9657 27.8382 44.9657 25.8004V6.0116C44.9657 3.97383 46.6218 2.31776 48.6595 2.31776H63.9685ZM39.3634 5.2658C39.3634 2.81621 41.3572 0.82239 43.8068 0.82239H66.2587L63.912 1.49411H48.6595C46.1685 1.49411 44.1408 3.52058 44.1408 6.0116V25.6372L39.3621 30.7335V5.2658H39.3634Z'
                          fill='#E60000'
                        />
                        <path
                          d='M107.734 40.1777H82.3439C79.4398 40.1777 77.0781 42.5394 77.0781 45.4423V71.9508C77.0781 74.8549 79.4411 77.2154 82.3439 77.2154H107.734C110.638 77.2154 113 74.8537 113 71.9508V45.4423C113 42.5394 110.637 40.1777 107.734 40.1777ZM102.507 42.4955C104.546 42.4955 106.203 44.1528 106.203 46.1881V65.9782C106.203 68.0159 104.546 69.6732 102.507 69.6732H87.1966C85.1601 69.6732 83.5028 68.0159 83.5028 65.9782V46.1881C83.5028 44.1528 85.1601 42.4955 87.1966 42.4955H102.507ZM77.9005 45.4423C77.9005 42.9927 79.8943 41.0014 82.3439 41.0014H104.797L102.449 41.6706H87.1966C84.7069 41.6706 82.6792 43.6958 82.6792 46.1881V65.8162L77.8993 70.9125L77.9005 45.4423Z'
                          fill='#E60000'
                        />

                        <path
                          d='M49.7217 15.3365H52.0018V22.8058H52.9208V15.3365H55.2022L52.4613 10.5918L49.7217 15.3365Z'
                          fill='#E60000'
                        />
                        <path
                          d='M14.4533 54.2339L9.70605 56.976L14.4533 59.7156V57.4318H21.9226V56.5152H14.4533V54.2339Z'
                          fill='#E60000'
                        />
                        <path
                          d='M52.9208 50.8726H52.0018V58.3419H49.7217L52.4613 63.0866L55.2022 58.3419H52.9208V50.8726Z'
                          fill='#E60000'
                        />
                        <path
                          d='M93.5247 56.5152H86.0566V57.4318H93.5247V59.7156L98.2719 56.976L93.5247 54.2339V56.5152Z'
                          fill='#E60000'
                        />
                        <path
                          d='M93.5247 59.7156V57.4355H86.0566V56.5189H93.5247V54.2363L98.2707 56.981L93.5247 59.7156Z'
                          fill='#E60000'
                        />
                        <path
                          d='M52.4616 63.0866L49.7207 58.3419H52.0008V50.8726H52.9186V58.3419H55.1999L52.4616 63.0866Z'
                          fill='#E60000'
                        />
                        <path
                          d='M21.9226 57.4316H14.4533V59.7142L9.70605 56.9721L14.4533 54.23V56.5101H21.9226V57.4316Z'
                          fill='#E60000'
                        />
                        <path
                          d='M52.9208 15.3365V22.8058H52.0043V15.3365H49.7217L52.4638 10.5918L55.2059 15.3365H52.9208Z'
                          fill='#E60000'
                        />
                      </svg>
                      <span className={styles["wiv-tip-text"]}>
                        Move around the 3D platform by pressing the or using{" "}
                        <span className={styles["wiv-tip-text-bolder"]}>
                          arrow keys{" "}
                        </span>
                        the{" "}
                        <span className={styles["wiv-tip-text-bolder"]}>
                          WASD
                        </span>{" "}
                        keys.
                      </span>
                    </div>
                  )}

                  <div className={styles["wiv-tip"] + " col-md-6"}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='37'
                      height='37'
                      viewBox='0 0 37 37'
                      fill='none'
                    >
                      <path
                        d='M18.4816 16.1713C18.1753 16.1761 17.8834 16.3022 17.6701 16.5219C17.4567 16.7417 17.3392 17.0371 17.3434 17.3434V25.4371C17.3412 25.5903 17.3695 25.7425 17.4267 25.8846C17.4838 26.0268 17.5686 26.1562 17.6762 26.2653C17.7838 26.3745 17.912 26.4611 18.0533 26.5202C18.1947 26.5794 18.3464 26.6098 18.4996 26.6098C18.6529 26.6098 18.8046 26.5794 18.9459 26.5202C19.0873 26.4611 19.2155 26.3745 19.3231 26.2653C19.4306 26.1562 19.5155 26.0268 19.5726 25.8846C19.6297 25.7425 19.658 25.5903 19.6559 25.4371V17.3434C19.658 17.1887 19.6291 17.0351 19.5708 16.8918C19.5125 16.7485 19.426 16.6184 19.3165 16.5091C19.207 16.3998 19.0767 16.3136 18.9333 16.2555C18.7899 16.1975 18.6363 16.1689 18.4816 16.1713Z'
                        fill='#E60000'
                      />
                      <path
                        d='M18.5 12.7188C19.1386 12.7188 19.6562 12.2011 19.6562 11.5625C19.6562 10.9239 19.1386 10.4062 18.5 10.4062C17.8614 10.4062 17.3438 10.9239 17.3438 11.5625C17.3438 12.2011 17.8614 12.7188 18.5 12.7188Z'
                        fill='#E60000'
                      />
                      <path
                        d='M18.5 2.3125C9.57363 2.3125 2.3125 9.57363 2.3125 18.5C2.3125 27.4264 9.57363 34.6875 18.5 34.6875C27.4264 34.6875 34.6875 27.4264 34.6875 18.5C34.6875 9.57363 27.4264 2.3125 18.5 2.3125ZM18.5 4.625C26.1767 4.625 32.375 10.8233 32.375 18.5C32.375 26.1767 26.1767 32.375 18.5 32.375C10.8233 32.375 4.625 26.1767 4.625 18.5C4.625 10.8233 10.8233 4.625 18.5 4.625Z'
                        fill='#E60000'
                      />
                    </svg>
                    <span className={styles["wiv-tip-text"]}>
                      Access detailed information by{" "}
                      <span className={styles["wiv-tip-text-bolder"]}>
                        clicking
                      </span>{" "}
                      the information icon.
                    </span>
                  </div>
                  {isMobile ? (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <img
                        src='/wiv/instructionTouch.svg'
                        className={styles["img"]}
                      ></img>
                      <span className={styles["wiv-tip-text"]}>
                        Explore information about any clickable link by{" "}
                        <span className={styles["wiv-tip-text-bolder"]}>
                          Long Press Touch
                        </span>{" "}
                        on them.
                      </span>
                    </div>
                  ) : (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='28'
                        height='42'
                        viewBox='0 0 28 42'
                        fill='none'
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14 42C6.268 42 0 35.732 0 28V14C0 6.268 6.268 0 14 0C21.732 0 28 6.268 28 14V28C28 35.732 21.732 42 14 42ZM2 20H26V28C26 34.627 20.627 40 14 40C7.373 40 2 34.627 2 28V20ZM12.117 14.583C12.385 14.761 12.685 14.885 13 14.949V18H6.26601L12.117 14.583ZM11 10.603V12.5C11 12.635 11.011 12.769 11.032 12.9L2.30099 18H2V15.86L11 10.603ZM15 6.05103V2.04099C21.159 2.54899 26 7.709 26 14V18H15V14.949C15.477 14.852 15.919 14.617 16.268 14.268C16.737 13.799 17 13.163 17 12.5V8.5C17 7.837 16.737 7.20099 16.268 6.73199C15.919 6.38299 15.477 6.14803 15 6.05103ZM13 4.802V6.05103C12.523 6.14803 12.081 6.38299 11.732 6.73199C11.315 7.14899 11.061 7.69801 11.01 8.28101L2.009 13.538C2.042 12.668 2.16701 11.821 2.37601 11.008L13 4.802ZM15 12.5V8.5C15 8.367 14.947 8.24 14.854 8.146C14.76 8.053 14.633 8 14.5 8H13.5C13.367 8 13.24 8.053 13.146 8.146C13.053 8.24 13 8.367 13 8.5V12.5C13 12.633 13.053 12.76 13.146 12.854C13.24 12.947 13.367 13 13.5 13H14.5C14.633 13 14.76 12.947 14.854 12.854C14.947 12.76 15 12.633 15 12.5ZM13 2.48599L3.629 7.96002C5.551 4.66602 8.997 2.37099 13 2.04099V2.48599Z'
                          fill='#E60000'
                        />
                      </svg>
                      <span className={styles["wiv-tip-text"]}>
                        Explore information about any clickable link by
                        <span className={styles["wiv-tip-text-bolder"]}>
                          {" "}
                          left-clicking
                        </span>{" "}
                        on them.
                      </span>
                    </div>
                  )}
                  <div className={styles["wiv-tip"] + " col-md-6"}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='35'
                      height='34'
                      viewBox='0 0 35 34'
                      fill='none'
                    >
                      <path
                        d='M32.2932 7.18029L23.5849 4.95259C23.5802 4.95139 23.5794 4.95094 23.5746 4.94982C23.5597 4.9463 23.5467 4.94361 23.5316 4.94092C23.5179 4.93853 23.5053 4.93606 23.4916 4.93442C23.4766 4.93255 23.4621 4.93165 23.4471 4.93068C23.432 4.92971 23.4194 4.92873 23.4054 4.92858C23.3913 4.92843 23.3758 4.92918 23.3608 4.92985C23.3459 4.93053 23.3326 4.93098 23.3185 4.9324C23.3044 4.93382 23.2895 4.93621 23.2749 4.93853C23.2604 4.94085 23.2464 4.94279 23.2323 4.94601C23.2282 4.9469 23.2241 4.9472 23.22 4.9481L17.0532 6.35869C16.6568 5.276 16.0253 4.28861 15.2014 3.46341C15.1486 3.38847 15.0822 3.32344 15.0055 3.27147C13.485 1.81591 11.435 0.999906 9.29915 1.00002C7.10574 0.995798 5.00016 1.83607 3.44432 3.33649C1.88847 4.83691 1.00942 6.87497 1 9.00356C1.00292 9.92902 1.16688 10.8474 1.48495 11.7198V28.6598C1.48518 29.1609 1.65829 29.6475 1.97668 30.042C2.29507 30.4365 2.74041 30.7162 3.24168 30.8364L12.6571 33.1118C12.6571 33.1267 12.767 33.1342 12.8299 33.1342C12.8905 33.1341 12.9508 33.1265 13.0095 33.1118L23.3934 30.6008L31.1259 32.6058C31.3221 32.657 31.5243 32.683 31.7275 32.6831C32.2299 32.6826 32.7176 32.5188 33.1129 32.2178C33.3927 32.0083 33.6185 31.7385 33.7725 31.4297C33.9264 31.121 34.0042 30.7817 33.9998 30.4387V9.34953C34.0029 8.85562 33.8371 8.37467 33.5282 7.98209C33.2193 7.58952 32.785 7.30751 32.2932 7.18029ZM4.51299 4.40936C5.13582 3.79936 5.87713 3.3153 6.69402 2.98519C7.51091 2.65508 8.38715 2.48548 9.27203 2.4862H9.29422C10.1706 2.48566 11.0383 2.65512 11.8463 2.98462C12.6543 3.31413 13.3862 3.79703 13.9992 4.40495C14.0007 4.40644 14.0022 4.41018 14.0037 4.41168C14.6298 5.0145 15.1268 5.7316 15.4661 6.52165C15.8054 7.3117 15.9803 8.15909 15.9807 9.015C15.981 9.87092 15.8069 10.7185 15.4682 11.5088C15.1296 12.2991 14.6332 13.0166 14.0076 13.6199L9.20577 18.2145L4.47894 13.6274C3.85716 13.0189 3.3651 12.2974 3.03091 11.5042C2.69673 10.711 2.52697 9.86168 2.53136 9.00475C2.53025 8.14939 2.70493 7.3024 3.04519 6.51334C3.38545 5.72429 3.88445 5.00901 4.51299 4.40936ZM3.02594 28.6598V14.283C3.10299 14.4191 3.26379 14.5522 3.39578 14.6817L8.66226 19.7972C8.73285 19.8663 8.81679 19.9212 8.90927 19.9588C9.00175 19.9964 9.10097 20.0159 9.20123 20.0162C9.3015 20.0166 9.40085 19.9978 9.49361 19.9608C9.58636 19.9239 9.6707 19.8695 9.7418 19.8009L12.0407 17.5973V31.4293L3.59795 29.3853C3.43233 29.3446 3.28574 29.2508 3.18192 29.1191C3.0781 28.9874 3.02313 28.8256 3.02594 28.6598ZM13.5817 16.1228L15.0907 14.6817C15.8613 13.9406 16.4728 13.0585 16.8899 12.0865C17.3069 11.1146 17.5212 10.072 17.5203 9.01911C17.5156 8.61386 17.4793 8.20953 17.4118 7.80958L22.5965 6.62017V29.2441L13.5817 31.4293V16.1228ZM32.4588 30.4387C32.4623 30.5523 32.4383 30.6651 32.3888 30.768C32.3393 30.871 32.2656 30.9613 32.1737 31.0317C32.079 31.102 31.9688 31.1502 31.8518 31.1726C31.7348 31.195 31.614 31.1911 31.4988 31.1611L24.1375 29.2542V6.64582L31.8858 8.62648C32.0502 8.66868 32.1955 8.76251 32.2992 8.8933C32.4029 9.0241 32.459 9.18452 32.4588 9.34953V30.4387Z'
                        fill='#E60000'
                        stroke='#E60000'
                        stroke-width='0.3'
                      />
                      <path
                        d='M9.27738 12.6715C10.0404 12.6715 10.7863 12.4519 11.4207 12.0405C12.0552 11.6291 12.5497 11.0444 12.8417 10.3603C13.1337 9.67618 13.2101 8.9234 13.0612 8.19714C12.9123 7.47088 12.5449 6.80378 12.0054 6.28017C11.4658 5.75657 10.7784 5.4 10.03 5.25553C9.28166 5.11107 8.50595 5.18522 7.80101 5.46859C7.09606 5.75196 6.49353 6.23183 6.06962 6.84752C5.6457 7.46321 5.41943 8.18706 5.41943 8.92755C5.42058 9.92017 5.8274 10.8718 6.55066 11.5737C7.27392 12.2756 8.25454 12.6704 9.27738 12.6715ZM9.27738 6.67905C9.73563 6.67905 10.1836 6.81093 10.5646 7.05799C10.9456 7.30506 11.2426 7.65623 11.418 8.06709C11.5933 8.47795 11.6392 8.93004 11.5498 9.36621C11.4604 9.80237 11.2397 10.203 10.9157 10.5175C10.5917 10.8319 10.1788 11.0461 9.72939 11.1328C9.27995 11.2196 8.81409 11.1751 8.39072 11.0049C7.96735 10.8347 7.60549 10.5465 7.3509 10.1767C7.09631 9.80698 6.96042 9.37226 6.96042 8.92755C6.96101 8.33139 7.20531 7.75981 7.6397 7.33826C8.07408 6.91671 8.66306 6.67963 9.27738 6.67905Z'
                        fill='#E60000'
                        stroke='#E60000'
                        stroke-width='0.3'
                      />
                    </svg>
                    <span className={styles["wiv-tip-text"]}>
                      Navigate to any location on the event by{" "}
                      <span className={styles["wiv-tip-text-bolder"]}>
                        clicking on the map icon
                      </span>
                      .
                    </span>
                  </div>
                  {isMobile ? (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <img
                        src='/wiv/InstructionRotate.svg'
                        width='55'
                        height='42'
                      ></img>

                      <span className={styles["wiv-tip-text"]}>
                        Explore event environment by dragging
                        <span className={styles["wiv-tip-text-bolder"]}>
                          {" "}
                          Right and left
                        </span>{" "}
                        to navigate.
                      </span>
                    </div>
                  ) : (
                    <div className={styles["wiv-tip"] + " col-md-6"}>
                      <img src='/wiv/Mouse.svg' width='55' height='42'></img>

                      <span className={styles["wiv-tip-text"]}>
                        Explore the 3D platform by rotating and looking around
                        using the{" "}
                        <span className={styles["wiv-tip-text-bolder"]}>
                          left-clicking and drag
                        </span>
                        .
                      </span>
                    </div>
                  )}
                </div>
                <span
                  className={styles["wiv-btn"]}
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={() => {
                    if (document.getElementById("iframe")) {
                      window.localStorage.setItem("firsttime", "false");
                      document.getElementById("iframe").focus();
                    } else if (document.getElementById("iframe2")) {
                      window.localStorage.setItem("firsttime2", "false");
                      document.getElementById("iframe2").focus();
                    }
                  }}
                >
                  Get Started
                </span>
              </div>
              {/*..<p>This User is logged in from another browser</p> */}
            </div>
          </div>
        </div>
      </div>
      {/* Comment out concurrent user button and modal for testing */}
      {/*
      <button
        type='button'
        class='btn btn-primary'
        data-bs-toggle='modal'
        data-bs-target='#concurrentuser'
        id='concurrentuserbtn'
        style={{ display: "none" }}
      >
        ConcurrentUser
      </button>
      <div
        className='modal fade'
        id='concurrentuser'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-lg' role='document'>
          <div className='modal-content'>
            <div
              className='modal-body row'
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p>This User is logged in from another browser</p>
              <button
                className='btn btn-danger col-md-6 mb-2'
                onClick={(e) => {
                  handleDuplicateLogin();
                }}
              >
                Continue Session{" "}
              </button>
              <button
                className='btn btn-danger col-md-6'
                onClick={(e) => {
                  getCurrentUser().then((r) => {
                    axios
                      .post(`${process.env.REACT_APP_SERVER_URL}auth/logout`, {
                        email: r.preferred_username,
                      })
                      .then((x) => {
                        Cookies.remove("app_token");
                        window.location.href =
                          "https://login.microsoftonline.com/common/oauth2/logout";
                      });
                  });
                }}
              >
                Log out{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      */}
      <button
        type='button'
        class='btn btn-primary'
        data-bs-toggle='modal'
        data-bs-target='#expiredtoken'
        id='expiredtokenbtn'
        style={{ display: "none" }}
      >
        ConcurrentUser
      </button>
      <div
        className='modal fade'
        id='expiredtoken'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-lg' role='document'>
          <div className='modal-content'>
            <div
              className='modal-body row'
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p>
                Your Session Has expired please logout to aquire a new token{" "}
              </p>
              <button
                className='btn btn-danger col-md-6'
                onClick={(e) => {
                  getCurrentUser().then((r) => {
                    axios
                      .post(`${process.env.REACT_APP_SERVER_URL}auth/logout`, {
                        email: r.preferred_username,
                      })
                      .then((x) => {
                        Cookies.remove("app_token");
                        window.location.href =
                          "https://login.microsoftonline.com/common/oauth2/logout";
                      });
                  });
                }}
              >
                Log out{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        data-bs-target={"#summit-agenda"}
        data-bs-toggle={"modal"}
        rel='noreferrer'
        target='_blank'
        id='summit-agenda-btn-modal'
        style={{ display: "none" }}
      >
        View Agenda
      </button>
      <div
        className='modal fade'
        id={"summit-agenda"}
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-lg' role='document'>
          <div className='modal-content'>
            <div
              className='modal-body row'
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src='/assets/summit/Summit_Agenda.png'
                style={{ width: "45rem" }}
              ></img>
            </div>
          </div>
        </div>
      </div>

      <Routes>
        <Route path='/' element={<AdminProtectedRoute></AdminProtectedRoute>}>
          <Route
            path='/viewmail'
            user={current}
            element={<WivaViewMailTemplate />}
          />
          <Route
            path='/managetemplate'
            user={current}
            element={<WivaTemplateConfig />}
          />
          <Route
            path='/managewivaassets'
            user={current}
            element={<WIVAConfigPage />}
          />
          {/* WEBAR screens */}
          <Route path='/hackathon' user={current} element={<Hall />} />
          <Route path='/onboarding' user={current} element={<Onboarding />} />
          <Route path='/webar' user={current} element={<Main />} />
          <Route path='/earth' user={current} element={<EarthSplashScreen />} />
          <Route path='/stats' user={current} element={<AdminDashBoard />} />
          <Route
            path='/statscriteria'
            user={current}
            element={<StatsCriteria />}
          />

          {/*element={<UserManagementProfiles}*/}
          <Route
            path='/users'
            user={current}
            element={<UserManagementProfiles />}
          />
          {/*element={<AddParticipants}*/}
          <Route
            path='/AddParticipants'
            user={current}
            element={<AddParticipants />}
          />
          {/*element={<AddProject}*/}
          <Route path='/addproject' user={current} element={<AddProject />} />
          {/*element={<AddSuperAdmin}*/}
          <Route
            path='/addsuperadmin'
            user={current}
            element={<AddSuperAdmin />}
          />
          {/*element={<Projects} */}
          {/*element={<ProjectScreen}*/}
          <Route path='/projects' user={current} element={<Projects />} />
          {/*element={<AddAssets}*/}
          <Route path='/addassets' user={current} element={<AddAssets />} />
          <Route path='/addadmins' user={current} element={<AddAdmins />} />
          {/* general Event Screens */}
          {/*element={<Addparts}*/}
          <Route path='/addparts' user={current} element={<Addparts />} />
          <Route index element={<Navigate to='/home' replace />} />
        </Route>
        <Route path='/' element={<ProtectedRoute></ProtectedRoute>}>
          <Route
            user={current}
            path='/wiv/guru'
            element={<WIVASponcers />}
          ></Route>
          <Route
            user={current}
            path='/wiv/takephoto'
            element={<WIVAPhotobooth />}
          ></Route>
          <Route
            user={current}
            path='/wiv/mosaicwall'
            element={<WIVAMosaicWall />}
          ></Route>
          <Route
            path='/wiv/visitorpass'
            user={current}
            element={<WivaVistorPass />}
          />{" "}
          <Route path='/wiv/videos' user={current} element={<WIVAVideos />} />
          <Route
            path='/wiv/photoboothentrance'
            user={current}
            element={<WIVAPhotoBoothEntrance />}
          />
          <Route
            path='/wiv/newsletter'
            user={current}
            element={<WIVANewsLetter />}
          />
          <Route
            path='/wiv/session'
            user={current}
            element={<WIVAMainStage />}
          />
          <Route
            path='/wiv/livechat'
            user={current}
            element={<WIVALiveChat />}
          />
          <Route
            path='/wiv/createchatroom'
            user={current}
            element={<WIVAChatCreateRoom />}
          />
          <Route
            path='/wiv/chatentry'
            user={current}
            element={<WIVAChatEnryPage />}
          />
          <Route path='/wiv/home' user={current} element={<WIVAHome2 />} />
          <Route path='/wiv/' user={current} element={<WIVAHome />} />
          {/* admin screens */}
          {/* element={<underMaintenance} */}
          {/* element={<StatsCriteria} */}
          <Route path='/entrance' element={<Entrance />}></Route>
          {/* user screens */}
          {/*element={<ProjectScreen2} */}
          {/*showroom */}
          {/* OIT */}
          <Route
            path='/user/project'
            user={current}
            element={<ProjectScreen />}
          />
          <Route user={current} path='/oit/hwhall' element={<HWHall />}></Route>
          <Route
            user={current}
            path='/oit/itshall'
            element={<ITSHall />}
          ></Route>
          <Route
            user={current}
            path='/oit/collaborationshall'
            element={<CollaborationsHall />}
          ></Route>
          <Route user={current} path='/oit/oshall' element={<OSHall />}></Route>
          <Route
            user={current}
            path='/oit/infrastructurehall'
            element={<InfrastructureHall />}
          ></Route>
          <Route
            user={current}
            path='/oit/it-tshall'
            element={<ITTSHall />}
          ></Route>
          <Route user={current} path='/oit/sdhall' element={<SDHall />}></Route>
          <Route
            user={current}
            path='/oit/rtchall'
            element={<RTCHall />}
          ></Route>
          <Route
            user={current}
            path='/oit/vcihall'
            element={<VCIHall />}
          ></Route>
          <Route
            path='/showroom/oithall'
            user={current}
            element={<OITHall />}
          />
          <Route
            path='/showroom/aohall'
            user={current}
            element={<ShowRoomAOHall />}
          />
          <Route
            path='/showroom/guildscatalogue'
            user={current}
            element={<GuildsCatalogue />}
          />
          <Route
            path='/showroom/seguildshall'
            user={current}
            element={<GuildsHall />}
          />
          <Route
            path='/showroom/seprojectshall'
            user={current}
            element={<ProjectsHall />}
          />
          <Route path='/showroom/sehall' user={current} element={<SEHall />} />
          <Route
            path='/showroom/productivitycontactus'
            user={current}
            element={<ProductivityContactUs />}
          />
          <Route
            path='/showroom/productivityabout'
            user={current}
            element={<ProductivityAboutUs />}
          />
          <Route
            path='/showroom/productivity'
            user={current}
            element={<ProductivityHall />}
          />
          <Route
            path='/showroom/pmocontactus'
            user={current}
            element={<PMOContactUs />}
          />
          <Route
            path='/showroom/pmoabout'
            user={current}
            element={<PMOAboutUs />}
          />
          <Route path='/showroom/pmo' user={current} element={<PMOHall />} />
          <Route
            path='/showroom/coecontactus'
            user={current}
            element={<COEContactUs />}
          />
          <Route
            path='/showroom/coeabout'
            user={current}
            element={<COEAboutUs />}
          />
          <Route path='/showroom/coe' user={current} element={<COEHall />} />
          <Route
            path='/showroom/digitaltoolingcontactus'
            user={current}
            element={<DigitalToolingContactUs />}
          />
          <Route
            path='/showroom/digitaltoolingabout'
            user={current}
            element={<DigitalToolingAboutUs />}
          />
          <Route
            path='/showroom/digitaltooling'
            user={current}
            element={<DigitalToolingHall />}
          />
          <Route
            path='/showroom/rpacontactus'
            user={current}
            element={<RPAContactUs />}
          />
          <Route
            path='/showroom/rpaabout'
            user={current}
            element={<RPAAboutUs />}
          />
          <Route path='/showroom/rpa' user={current} element={<RPAHall />} />
          <Route
            path='/showroom/bpmcontactus'
            user={current}
            element={<BPMContactUs />}
          />
          <Route
            path='/showroom/bpmabout'
            user={current}
            element={<BPMAboutUs />}
          />
          <Route path='/showroom/bpm' user={current} element={<BPMHall />} />
          <Route
            path='/showroom/devopscontactus'
            user={current}
            element={<DevOpsContactUs />}
          />
          <Route
            path='/showroom/devopsabout'
            user={current}
            element={<DevOpsAboutUs />}
          />
          <Route
            path='/showroom/devops'
            user={current}
            element={<DevOpsHall />}
          />
          <Route
            path='/showroom/dsmcontactus'
            user={current}
            element={<DSMContactUs />}
          />
          <Route
            path='/showroom/dsmabout'
            user={current}
            element={<DSMAboutUs />}
          />
          <Route path='/showroom/dsm' user={current} element={<DSMHall />} />
          <Route
            path='/showroom/testingcontactus'
            user={current}
            element={<TestingContactUs />}
          />
          <Route
            path='/showroom/testingabout'
            user={current}
            element={<TesingAboutUs />}
          />
          <Route
            path='/showroom/testing'
            user={current}
            element={<TestingHall />}
          />
          <Route
            path='/showroom/seahall'
            user={current}
            element={<SEAHall />}
          />
          <Route
            path='/showroom/hrcomingsoon'
            user={current}
            element={<HRComingSoon />}
          />
          <Route
            path='/showroom/bqahall'
            user={current}
            element={<ShowRoomBQAHall />}
          />
          <Route
            path='/showroom/teshall'
            user={current}
            element={<ShowRoomTesHall />}
          />
          <Route
            path='/showroom/opchall'
            user={current}
            element={<ShowRoomOPCHall />}
          />
          <Route
            path='/showroom'
            user={current}
            element={<ShowRoomMainHall />}
          />
          {/*3rd Ascention screens */}
          <Route path='/asc3/home' element={<AscensionHome />} />
          <Route
            path='/asc3/game'
            user={current}
            element={<AscensionDayGame />}
          />
          <Route
            path='/asc3/gameentrance'
            user={current}
            element={<AscensionGameEntrance />}
          />
          <Route
            path='/asc3/session'
            user={current}
            element={<ThirdAscensionKeyNotes />}
          />
          <Route
            path='/asc3/gallerywall'
            user={current}
            element={<ThirdAscensionGallerywall />}
          />
          <Route
            path='/asc3/takephoto'
            user={current}
            element={<ThirdAscensionTakePhoto />}
          />
          <Route
            path='/asc3/photoboothentrance2'
            user={current}
            element={<ThirdAscensionPhotoBoothEntrance2 />}
          />
          <Route
            path='/asc3/photoboothentrance'
            user={current}
            element={<ThirdAscensionPhotoBoothEntrance />}
          />
          <Route
            path='/asc3/chatrooms'
            user={current}
            element={<ThirdAscensionChatRooms />}
          ></Route>
          <Route
            path='/asc3/chatEntrance'
            user={current}
            element={<ThirdAscensionChatEntrance />}
          />
          <Route
            path='/asc3/breakroom'
            user={current}
            element={<ThirdAscensionBreakAreaEntrance />}
          />
          <Route
            path='/asc3/hall'
            user={current}
            element={<ThirdAscensionHall />}
          />
          {/* <Route path='/asc3/agenda' element={<ThirdAscAgenda />} />
          <Route path='/asc3/configagenda' element={<AgendaConfiguire />} /> */}
          <Route
            path='/asc3'
            user={current}
            element={<ThirdAscensionEntranceVideo />}
          />
          {/*element={<ErrorPage}*/}
          <Route path='/unauthorized' user={current} element={<ErrorPage />} />
          <Route index path='*' element={<LoginForm />} />
        </Route>
        <Route index path='/home' element={<LoginForm />} />
        {/* WEBAR screens */}

        {/*element={<LoginFormNonVodafone} */}
      </Routes>
    </>
  );
}

export default App;
